import api from '../../api'
import {
  COMMON_LOAD_INITIAL_DATA,
  COMMON_LOAD_INITIAL_DATA_FAILED,
  COMMON_LOAD_INITIAL_DATA_SUCCESS
} from '../mutations/available'
import {RequestState} from "../../requestState";

export const commonGetInitialData = async ({commit}) => {
  commit(COMMON_LOAD_INITIAL_DATA);

  let initialData = null;
  try {
    initialData = await api.getInitialData();
    commit(COMMON_LOAD_INITIAL_DATA_SUCCESS, initialData)
  } catch (e) {
    commit(COMMON_LOAD_INITIAL_DATA_FAILED, e);
    console.log(`Unable to get initial data, details: ${e.message}`)
  }

  return initialData
};

export async function fetchInitDataIfRequired({commit, dispatch, state}) {
  if (state.fetchInitDataRequestState === RequestState.Success ||
      state.fetchInitDataRequestState === RequestState.Loading) {
    return
  }

  return dispatch('commonGetInitialData')
}




// WEBPACK FOOTER //
// ./src/store/actions/common.js